
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import {ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
//import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserService } from './shared/services/user.service';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserComponent } from './user/user.component';
import { RegistrationComponent } from './user/registration/registration.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ProductComponent } from './product/product.component';
import { ProductListComponent } from './product/product-list/product-list.component';
import { ProductDetailComponent } from './product/product-detail/product-detail.component';
import { TechSupportComponent } from './techsupport/techsupport.component';

import { MaterialModule} from './modules/material/material.module';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { FaqComponent } from './faq/faq.component';
import { FaqListComponent } from './faq/faq-list/faq-list.component';
import { FaqDetailComponent } from './faq/faq-detail/faq-detail.component'
import { FaqEditComponent } from './faq/faq-edit/faq-edit.component';
import { FaqpopupComponent } from './faqpopup/faqpopup.component';
import { FindCustomerStepComponent } from './techsupport/find-customer-step/find-customer-step.component';
import { CallProcessComponent, FormatTimePipe } from './call-process/call-process.component';

import { CallLogComponent } from './calllog/calllog.component';
import { CallLogListComponent } from './calllog/calllog-list/calllog-list.component';
import { CallLogDetailComponent } from './calllog/calllog-detail/calllog-detail.component';
import { ClientComponent } from './client/client.component';
import { ClientListComponent } from './client/client-list/client-list.component';
import { ClientDetailComponent } from './client/client-detail/client-detail.component';
import { FindIssueStepComponent } from './techsupport/find-issue-step/find-issue-step.component';
import { FindSolutionStepComponent } from './techsupport/find-solution-step/find-solution-step.component';
import { FinishStepComponent } from './techsupport/finish-step/finish-step.component';
import { IssueCategoryComponent } from './issue/issue-category/issue-category.component';
import { IssueCategoryListComponent } from './issue/issue-category/issue-category-list/issue-category-list.component';
import { IssueCategoryDetailComponent } from './issue/issue-category/issue-category-detail/issue-category-detail.component';
import { ProductCategoryListComponent } from './product/product-category/product-category-list/product-category-list.component';
import { ProductCategoryDetailComponent } from './product/product-category/product-category-detail/product-category-detail.component';
import { ProductCategoryComponent } from './product/product-category/product-category.component';
import { IssueComponent } from './issue/issue.component';
import { IssueListComponent } from './issue/issue-list/issue-list.component';
import { IssueDetailComponent } from './issue/issue-detail-container/issue-detail/issue-detail.component';
import { IssueDetailEditComponent } from './issue/issue-detail-container/issue-detail-edit/issue-detail-edit.component';
import { IssueDetailContainerComponent } from './issue/issue-detail-container/issue-detail-container.component';
import { IssueTrackComponent } from './issue/issue-track/issue-track.component';
import { IssueTrackEditComponent } from './issue/issue-track/issue-track-edit/issue-track-edit.component';
import { IssueTrackListComponent } from './issue/issue-track/issue-track-list/issue-track-list.component';
import { HeaderComponent } from './shared/component/header/header.component';
import { FooterComponent } from './shared/component/footer/footer.component';
import { SidebarComponent } from './shared/component/sidebar/sidebar.component';

import { TextFieldModule } from '@angular/cdk/text-field';
import { CalllogRecentComponent } from './calllog/calllog-recent/calllog-recent.component';
import { OpenedIssueComponent } from './issue/opened-issue/opened-issue.component';
import { CalllogChartComponent } from './calllog/calllog-chart/calllog-chart.component';

import { ChartsModule, ThemeService} from 'ng2-charts';
import { ChangePasswordComponent } from './user/change-password/change-password.component';
import { ProfileComponent } from './user/profile/profile.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { ForbiddenComponent} from './forbidden/forbidden.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UploadComponent } from './upload/upload.component';
import { UploadFormComponent } from './upload/upload-form/upload-form.component';
import { RmaShippingArrivalsComponent } from './rma/rma-shipping-arrivals/rma-shipping-arrivals.component';
import { RmaShippingArrivalsListComponent } from './rma/rma-shipping-arrivals/rma-shipping-arrivals-list/rma-shipping-arrivals-list.component';
import { RmaShippingArrivalsEditComponent } from './rma/rma-shipping-arrivals/rma-shipping-arrivals-edit/rma-shipping-arrivals-edit.component';
import { RmaShippingArrivalsDetailComponent } from './rma/rma-shipping-arrivals/rma-shipping-arrivals-detail/rma-shipping-arrivals-detail.component';
import { CourierComponent } from './rma/courier/courier.component';
import { CourierListComponent } from './rma/courier/courier-list/courier-list.component';
import { CourierDetailComponent } from './rma/courier/courier-detail/courier-detail.component';
import { TestComponent } from './test/test.component';
import { RmaRequestComponent } from './rma/rma-request/rma-request.component';
import { FindRmaCustomerStepComponent } from './rma/rma-request/find-rma-customer-step/find-rma-customer-step.component';
import { AddProductStepComponent } from './rma/rma-request/add-product-step/add-product-step.component';
import { ShippingInformationStepComponent } from './rma/rma-request/shipping-information-step/shipping-information-step.component';
import { ReviewAndFinishStepComponent } from './rma/rma-request/review-and-finish-step/review-and-finish-step.component';
import { EditProductItemComponent } from './rma/rma-request/add-product-step/edit-product-item/edit-product-item.component';
import { EditSRProductItemComponent } from './rma/rma-request/add-product-step/edit-sr-product-item/edit-sr-product-item.component';
import { DownloadComponent } from './download/download.component';
import { DownloadDetailComponent } from './download/download-detail/download-detail.component';
import { DownloadEditComponent } from './download/download-edit/download-edit.component';
import { DownloadContainerComponent } from './download/download-container/download-container.component';
import { RmaListComponent } from './rma/rma-list/rma-list.component';
import { RmaDetailComponent } from './rma/rma-detail/rma-detail.component';
import { RmaRecentComponent } from './rma/rma-recent/rma-recent.component';
import { BasicSnackbarComponent} from "./basic-snackbar/basic-snackbar.component"
import { GlobalNotification} from "./shared/constants/global-notification"

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    FetchDataComponent,
    LoginComponent,
    DashboardComponent,
    UserComponent,
    RegistrationComponent,
    ProductComponent,
    ProductListComponent,
    ProductDetailComponent,
    TechSupportComponent,
    SideMenuComponent,
    FaqComponent,
    FaqListComponent,
    FaqDetailComponent,
    FaqEditComponent,
    FaqpopupComponent,
    FindCustomerStepComponent,
    CallProcessComponent,
    FormatTimePipe,
    CallLogComponent,
    CallLogListComponent,
    CallLogDetailComponent,
    ClientComponent,
    ClientListComponent,
    ClientDetailComponent,
    FindIssueStepComponent,
    FindSolutionStepComponent,
    FinishStepComponent,
    IssueCategoryComponent,
    IssueCategoryListComponent,
    IssueCategoryDetailComponent,
    ProductCategoryListComponent,
    ProductCategoryDetailComponent,
    ProductCategoryComponent,
    IssueComponent,
    IssueListComponent,
    IssueDetailComponent,
    IssueDetailEditComponent,
    IssueDetailContainerComponent,
    IssueTrackComponent,
    IssueTrackEditComponent,
    IssueTrackListComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CalllogRecentComponent,
    OpenedIssueComponent,
    CalllogChartComponent,
    ChangePasswordComponent,
    ProfileComponent,
    UserListComponent,
    ForbiddenComponent,
    ResetPasswordComponent,
    UploadComponent,
    UploadFormComponent,
    RmaShippingArrivalsComponent,
    RmaShippingArrivalsListComponent,
    RmaShippingArrivalsEditComponent,
    RmaShippingArrivalsDetailComponent,
    CourierComponent,
    CourierListComponent,
    CourierDetailComponent,
    TestComponent,
    RmaRequestComponent,
    FindRmaCustomerStepComponent,
    AddProductStepComponent,
    ShippingInformationStepComponent,
    ReviewAndFinishStepComponent,
    EditProductItemComponent,
    EditSRProductItemComponent,
    DownloadComponent,
    DownloadDetailComponent,
    DownloadEditComponent,
    DownloadContainerComponent,
    RmaListComponent,
    RmaDetailComponent,
    RmaRecentComponent,
    BasicSnackbarComponent,

  ],
  imports: [
    CommonModule,
    MaterialModule,
    ChartsModule,
    TextFieldModule,
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
   // ToastrModule.forRoot(),
   /*
    ToastrModule.forRoot({
      toastClass: 'toast toast-bootstrap-compatibility-fix'
    }),*/
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: 'login', component: LoginComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      {
        path: '', component : HomeComponent, canActivate:[AuthGuard],
        children : [
          { path: '', component: DashboardComponent,canActivate:[AuthGuard]},
          { path: 'dashboard', component: DashboardComponent,canActivate:[AuthGuard]},
          { path: 'client', component: ClientComponent,canActivate:[AuthGuard]},
          { path: 'product', component: ProductComponent,canActivate:[AuthGuard]},
          { path: 'issue-category', component: IssueCategoryComponent,canActivate:[AuthGuard]},
          { path: 'product-category', component: ProductCategoryComponent,canActivate:[AuthGuard]},
          { path: 'faq-list', component: FaqListComponent,canActivate:[AuthGuard]},
          { path: 'faq-detail/:id', component: FaqDetailComponent,canActivate:[AuthGuard]},
          { path: 'calllog', component: CallLogComponent,canActivate:[AuthGuard]},
          { path: 'calllog-detail/:id', component: CallLogDetailComponent,canActivate:[AuthGuard]},
          { path: 'techsupport', component: TechSupportComponent, canActivate:[AuthGuard], canDeactivate:[AuthGuard]},
          { path: 'issue/:id', component: IssueComponent,canActivate:[AuthGuard]},
          { path: 'issue', component: IssueComponent,canActivate:[AuthGuard]},
          { path: 'issue-detail-container', component: IssueDetailContainerComponent,canActivate:[AuthGuard]},
          { path: 'rma-shipping-arrivals', component: RmaShippingArrivalsComponent,canActivate:[AuthGuard]},
          { path: 'rma-shipping-arrivals-edit/:id', component: RmaShippingArrivalsEditComponent,canActivate:[AuthGuard]},
          { path: 'rma-shipping-arrivals-edit', component: RmaShippingArrivalsEditComponent,canActivate:[AuthGuard]},
          { path: 'courier', component: CourierComponent,canActivate:[AuthGuard]},
          { path: 'test', component: TestComponent},
          { path: 'rma-request', component: RmaRequestComponent,canActivate:[AuthGuard]},
          { path: 'rma-recent', component: RmaRecentComponent,canActivate:[AuthGuard]},
          { path: 'rma-list/:type', component: RmaListComponent,canActivate:[AuthGuard]},
          { path: 'rma-detail/:id', component: RmaDetailComponent,canActivate:[AuthGuard]},
          { path: 'download-container/:id', component: DownloadContainerComponent,canActivate:[AuthGuard]},
          { path: 'download', component: DownloadComponent,canActivate:[AuthGuard]},
          { path: 'download-detail/:id', component: DownloadDetailComponent,canActivate:[AuthGuard]},
          {
            path: 'user', component: UserComponent,
            children: [
              { path: 'user-list', component: UserListComponent,canActivate:[AuthGuard]},
              { path: 'change-password', component: ChangePasswordComponent,canActivate:[AuthGuard]},
              { path: 'profile', component: ProfileComponent, canActivate:[AuthGuard] },

            ]
          },
          { path: 'forbidden', component: ForbiddenComponent}
      ]
      }
    ])
  ],
  providers: [  UserService, {
    provide : HTTP_INTERCEPTORS,
    useClass : AuthInterceptor,
    multi : true
    },
    ThemeService,
    AuthGuard,
    GlobalNotification
 ],
  bootstrap: [AppComponent],
  entryComponents:[
    ClientDetailComponent,
    FaqEditComponent,
    IssueCategoryDetailComponent,
    ProductCategoryDetailComponent,
    ProductDetailComponent,
    RegistrationComponent,
    CourierDetailComponent,
    EditProductItemComponent,
    EditSRProductItemComponent,
    DownloadEditComponent,
    BasicSnackbarComponent
  ]
})

export class AppModule { }
